$(document).ready(function () {
  // Product page custom accordian section
  $(" .Product_Data_Tabs .Collapsible__Button").click(function () {
    console.log("Click tab");
    let prent = $(this).closest(".Collapsible");
    prent
      .siblings(".Collapsible")
      .removeClass("open")
      .find(".Collapsible__Content")
      .slideUp();
    if (prent.hasClass("open")) {
      prent.removeClass("open").find(".Collapsible__Content").slideUp();
    } else {
      prent.addClass("open").find(".Collapsible__Content").slideDown();
    }
  });
  function productCustomAccordion(data, accordionData) {
    // Check if data exists
    if (data.length !== 0) {
      for (var i = 0; i < data.length; i++) {
        data[i].remove();
        accordionData.appendChild(data[i].cloneNode(true));
      }
    } else {
      accordionData.remove();
    }
  }

  //Features JS
  const productIngredients = document.querySelectorAll(
    ".ProductMeta__Description .productIngredients"
  );
  const productIngredients_accordion = document.querySelector(
    ".productIngredients_accordion .Collapsible__Content"
  );
  if (productIngredients && productIngredients_accordion) {
    productCustomAccordion(productIngredients, productIngredients_accordion);
  }

  //Shipping & Returns JS
  const productNutritionInfo = document.querySelectorAll(
    ".ProductMeta__Description .productNutritionInfo"
  );
  const productNutritionInfo_accordion = document.querySelector(
    ".productNutritionInfo_accordion .Collapsible__Content"
  );
  if (productNutritionInfo && productNutritionInfo_accordion) {
    productCustomAccordion(
      productNutritionInfo,
      productNutritionInfo_accordion
    );
  }

  //Taste Notes JS
  const productTasteNotes = document.querySelectorAll(
    ".ProductMeta__Description .productTasteNotes"
  );
  const producTasteNotes_accordion = document.querySelector(
    ".tasteNotes_accordion .Collapsible__Content"
  );
  if (productTasteNotes && producTasteNotes_accordion) {
    productCustomAccordion(productTasteNotes, producTasteNotes_accordion);
  }

  //Serving suggestions JS
  const productServingSuggestions = document.querySelectorAll(
    ".ProductMeta__Description .productServingSuggestions"
  );
  const productServingSuggestions_accordion = document.querySelector(
    ".servingSuggestions_accordion .Collapsible__Content"
  );
  if (productServingSuggestions && productServingSuggestions_accordion) {
    productCustomAccordion(
      productServingSuggestions,
      productServingSuggestions_accordion
    );
  }

  $(".Collapsible").each(function () {
    // Check if the <p> tag inside this section is empty
    if ($(this).find(".Collapsible__Inner").html().trim() === "") {
      $(this).remove();
    }
  });

  // product page faq
  let FaqData = document.querySelectorAll(".faqBlock .Item");

  FaqData.forEach(function (item) {
    let title = item.querySelector("h3").textContent;
    //let desc = item.querySelectorAll("p").innerHTML;

    let desc = "";
    let elements = item.querySelectorAll("p, ul");
    console.log(elements);

    elements.forEach(function (element, index) {
      if (element.tagName === "P") {
        desc += element.innerHTML + "<br><br>";
      } else if (element.tagName === "UL") {
        let lis = element.querySelectorAll("li");
        desc += "<ul>";
        lis.forEach(function (li) {
          desc += li.outerHTML;
        });
        desc += "</ul>";
      }
    });

    let collapsible = document.createElement("div");
    collapsible.classList.add("Collapsible");

    let button = document.createElement("button");
    button.classList.add("Collapsible__Button", "Heading", "u-h6");
    button.setAttribute("data-action", "toggle-collapsible");
    button.setAttribute("aria-expanded", "false");
    button.textContent = title;

    let span = document.createElement("span");
    span.classList.add("Collapsible__Plus");
    button.appendChild(span);

    let innerDiv = document.createElement("div");
    innerDiv.classList.add("Collapsible__Inner");

    let contentDiv = document.createElement("div");
    contentDiv.classList.add("Collapsible__Content");
    contentDiv.innerHTML = desc;

    innerDiv.appendChild(contentDiv);
    collapsible.appendChild(button);
    collapsible.appendChild(innerDiv);

    document.querySelector(".faqBlock").appendChild(collapsible);
    item.parentNode.removeChild(item);
  });

  // Add event listener for toggling collapsible elements
  $(" .faqBlock .Collapsible__Button").click(function () {
    let prent = $(this).closest(".Collapsible");
    prent
      .siblings(".Collapsible")
      .removeClass("open")
      .find(".Collapsible__Content")
      .slideUp();
    if (prent.hasClass("open")) {
      prent.removeClass("open").find(".Collapsible__Content").slideUp();
    } else {
      prent.addClass("open").find(".Collapsible__Content").slideDown();
    }
  });

  // Initially hide the element
  $(".sticky-add-to-cart").fadeOut();
  // sticky add to cart
  $(window).scroll(function () {
    if ($(this).scrollTop() > 800) {
      $(".sticky-add-to-cart").fadeIn();
    } else {
      $(".sticky-add-to-cart").fadeOut();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if ($("#related__products").length > 0) {
      console.log($(window).width());
      console.log($("#related__products").children().length);
      if (
        $(window).width() > 992 &&
        $("#related__products").children().length > 4
      ) {
        initSliderRel();
      } else if (
        $(window).width() > 589 &&
        $(window).width() <= 992 &&
        $("#related__products").children().length > 2
      ) {
        initSliderRel();
      } else if (
        $(window).width() <= 589 &&
        $("#related__products").children().length > 1
      ) {
        initSliderRel();
      } else {
        $("#related__products").addClass("grid");
      }
    }
  }, 5000);
});
function initSliderRel() {
  slideshow = new Flickity("#related__products", {
    loop: true,
    wrapAround: true,
    cellAlign: "left",
    pageDots: true,
    initialIndex: 1,
    accessibility: true, //true by default
    autoPlay: false, // advance cells every 3 seconds
  });
  window.dispatchEvent(new Event("resize"));
}

$(document).ready(function () {
  $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"]+label'
  ).trigger("click");
  $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"]+label'
  )
    .parents(".variant-input")
    .addClass("selected");
  var variant_title = $(
    ".product_variant_section_main .variant-input-wrap input[type=radio]:checked+label .option_title"
  ).text();
  var per_off = $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"][type=radio]:checked+label .option_percentage_off'
  ).attr("percentage");
  var comp_price = $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"][type=radio]:checked+label .option_compare_price'
  ).attr("compare_price");
  var variant_price = $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"][type=radio]:checked+label .option_product_price'
  ).attr("price");
  var variant_id = $(
    '.product_variant_section_main .variant-input-wrap input[recommended="true"][type=radio]:checked+label .option_product_price'
  ).attr("variant_id");
  $(
    ".product_variant_temp_section_main .sticky-add-to-cart .product__price.sale-price"
  ).text(`Rs. ${variant_price}.00`);

  $(
    ".product_variant_temp_section_main .sticky-add-to-cart .product-block-two select.product-single__variants option"
  ).removeAttr("selected");
  $(
    `.product_variant_temp_section_main .sticky-add-to-cart .product-block-two select.product-single__variants option[value="${variant_id}"]`
  ).attr("selected", "selected");

  if (per_off) {
    // $('button.shopify-payment-button__button').text('Complete Your Order');
    $(".option_percentage_off_price_bar").addClass("available");
    $(".option_percentage_off_price_bar").text(`${per_off}% OFF`);
    $(
      ".product_variant_temp_section_main .sticky-add-to-cart .product__price--compare"
    ).text(`Rs. ${comp_price}.00`);
  } else {
    $(".option_percentage_off_price_bar").removeClass("available");
  }

  
  $(".product_variant_title").text(variant_title);

  $(".product_variant_section_main .variant-input-wrap label").click(
    function () {
      var var_title = $(this).find(".option_title").text();
      $(".product_variant_title").text(var_title);
      var percentage_off = $(this)
        .find(".option_percentage_off")
        .attr("percentage");
      var compare_price = $(this)
        .find(".option_compare_price")
        .attr("compare_price");
      var var_price = $(this).find(".option_product_price").attr("price");
      var var_id = $(this).find(".option_product_price").attr("variant_id");
      $(
        ".product_variant_section_main .variant-input-wrap .variant-input"
      ).removeClass("selected");
      $(this).parents(".variant-input").addClass("selected");
      $(
        ".product_variant_temp_section_main .sticky-add-to-cart .product__price.sale-price"
      ).text(`Rs. ${var_price}.00`);
      $(
        ".product_variant_temp_section_main .sticky-add-to-cart .product-block-two select.product-single__variants option"
      ).removeAttr("selected");
      $(
        `.product_variant_temp_section_main .sticky-add-to-cart .product-block-two select.product-single__variants option[value="${var_id}"]`
      ).attr("selected", "selected");
      console.log(var_id, "var_idvar_id");
      if (percentage_off) {
        // $('button.shopify-payment-button__button').text('Complete Your Order');
        $(".option_percentage_off_price_bar").addClass("available");
        $(".option_percentage_off_price_bar").text(`${percentage_off}% OFF`);
        $(
          ".product_variant_temp_section_main .sticky-add-to-cart .product__price--compare"
        ).text(`Rs. ${compare_price}.00`);
      } else {
        $(".option_percentage_off_price_bar").removeClass("available");
      }
    }
  );

  $("button.sticky_buy_now_btn").click(function () {
    $(
      ".product-single__form .shopify-payment-button .shopify-payment-button__button--unbranded"
    ).trigger("click");
  });
  $("button.sticky_add_to_cart_btn.add-to-cart--secondary").click(function () {
    $(".product-single__form .add-to-cart").trigger("click");
  });
});

$(this).find(".grid__item").height("600px");



//  $(document).on("click", ".template-product .variant-input-wrap .variant-input", function () {
//    const selected_var = $(this).data("value");
//    let checkbox_limit = 0;

//   if (selected_var == "Pack of 1") {
//     $(".product-single__meta .select-free-gift").hide();
//   } else if (selected_var == "Pack of 2") {
//      // $(".select-free-gift .tile #tile-assam").hide();
//     $(".product-single__meta .select-free-gift").show();
//     checkbox_limit = 2;
//   } else if (selected_var == "Pack of 3") {
//     // $(".select-free-gift .tile #tile-assam").show();
//     $(".product-single__meta .select-free-gift").show();
//     checkbox_limit = 3;
//   }
  
//   $(".select-free-gift .tile input[type='checkbox']").prop("checked", false).prop("disabled", false);
//   $(".product_properties").empty(); // Clear all hidden inputs

//   $(".select-free-gift .tile input[type='checkbox']").off("change").on("change", function () {
//     const selected_count = $(".select-free-gift .tile input[type='checkbox']:checked").length;

//     if (selected_count >= checkbox_limit) {
//       $(".select-free-gift .tile input[type='checkbox']:not(:checked)").prop("disabled", true);
//     } else {
//       $(".select-free-gift .tile input[type='checkbox']").prop("disabled", false);
//     }

//     const checkbox_id = $(this).attr("id");
//     const checkbox_value = $(this).val();

//     if ($(this).is(":checked")) {
//       const property_number = $(".product_properties input[type='hidden']").length + 1;
//       const hidden_input_html = `<input type="hidden" name="properties[Trial Pack ${property_number}]" value="${checkbox_value}" id="property-${checkbox_id}">`;
//       $(".product_properties").append(hidden_input_html);
//     } else {
//       $(`#property-${checkbox_id}`).remove();
//       $(".product_properties input[type='hidden']").each(function (index) {
//         const new_property_name = `Trial Pack ${index + 1}`;
//         $(this).attr("name", `properties[${new_property_name}]`);
//       });
//     }
//   });
// }); 
